import PATH from '@/router/path';
import { isPblApplicationContext } from '@/utils/applications';
import { isPblUser } from '@/utils/pblRole';

type AccountMenuLink = {
  name: string;
  url?: string;
  children?: AccountMenuLink[];
};

type AccountMenuFilterOptions = {
  activeApplication?: ApplicationKey | null;
  pathname?: string;
};

export const canUseProfileEdit = (userData?: any, options: AccountMenuFilterOptions = {}) =>
  !isPblApplicationContext(options) && !isPblUser(userData);

export const filterAccountMenuLinks = <TLink extends AccountMenuLink>(
  links: TLink[],
  userData?: any,
  options: AccountMenuFilterOptions = {}
): TLink[] => {
  const allowProfileEdit = canUseProfileEdit(userData, options);

  return links.map((link) => {
    if (!Array.isArray(link.children)) return link;

    return {
      ...link,
      children: link.children.filter((child) => allowProfileEdit || child.url !== PATH.profile.edit),
    };
  });
};
